import { InteractionTypes } from '~/model/InteractionType';

export const defineDescriptionBasedOnType = (interactionType: string) => {
  const { survey, thread } = InteractionTypes;

  switch (interactionType) {
    case survey:
      return 'SURVEY';
    case thread:
      return 'THREAD';
    default:
      return 'SELECTION';
  }
};
